module.exports = __webpack_public_path__ + "static/media/convective-icon-general.5c4c748e.svg";